import styled from 'styled-components'

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: flex-end;
  button {
    width: 50%;
    margin: 0 10% 0 10%;
  }
`
